import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Tooltip,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import { QuestionOutlineIcon, CheckCircleIcon, WarningIcon } from '@chakra-ui/icons'
import { UseFormRegisterReturn } from 'react-hook-form'
import { useState } from 'react'

interface ControlInputWithHelpProps {
  register: UseFormRegisterReturn
  label: string
  placeholder?: string
  helpText?: string
  isInvalid?: boolean
  errorMessage?: string
  type?: string
  validatePattern?: RegExp
  showValidation?: boolean
  isDisabled?: boolean
  isReadOnly?: boolean
}

export default function ControlInputWithHelp({
  register,
  label,
  placeholder,
  helpText,
  isInvalid,
  errorMessage,
  type = 'text',
  validatePattern,
  showValidation = false,
  isDisabled = false,
  isReadOnly = false,
}: ControlInputWithHelpProps) {
  const [value, setValue] = useState('')
  const [isTouched, setIsTouched] = useState(false)

  const isValid = validatePattern && value ? validatePattern.test(value) : false
  const showFeedback = showValidation && isTouched && value.length > 0

  return (
    <FormControl isInvalid={isInvalid}>
      <FormLabel display="flex" alignItems="center" gap={2} fontSize="sm" fontWeight="medium">
        {label}
        {helpText && (
          <Tooltip label={helpText} fontSize="sm" placement="right" hasArrow>
            <QuestionOutlineIcon color="gray.400" boxSize={3.5} cursor="help" />
          </Tooltip>
        )}
      </FormLabel>
      <InputGroup>
        <Input
          {...register}
          type={type}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          borderRadius="lg"
          borderColor={isInvalid ? 'red.500' : 'gray.300'}
          bg={isReadOnly || isDisabled ? 'gray.50' : undefined}
          _hover={{ borderColor: isInvalid ? 'red.600' : 'gray.400' }}
          _focus={{
            borderColor: isInvalid ? 'red.500' : 'brand.purple',
            boxShadow: isInvalid ? '0 0 0 1px #FC8181' : '0 0 0 1px #6D3CFE',
          }}
          onChange={(e) => {
            setValue(e.target.value)
            register.onChange(e)
          }}
          onBlur={(e) => {
            setIsTouched(true)
            register.onBlur(e)
          }}
        />
        {showFeedback && (
          <InputRightElement>
            {isValid ? (
              <CheckCircleIcon color="green.500" />
            ) : (
              <WarningIcon color="orange.500" />
            )}
          </InputRightElement>
        )}
      </InputGroup>
      {isInvalid && errorMessage && (
        <FormErrorMessage fontSize="sm">{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  )
}
